import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

export function YoutubeExportSettings({ fieldPrefix }: { fieldPrefix?: string }) {
  const { $t } = useIntl();
  return (
    <Box>
      <UploadAssetFieldMui
        name={`${fieldPrefix || ''}.config.thumbnailUrl`.replace(/^\./, '')}
        inputProps={{
          label: $t({
            id: 'common.loadThumbnail',
            defaultMessage: 'Cargar thumbnail',
          }),
          size: 'sm',
          accept: 'image/*',
          maxSizeMb: 2,
          helperText: $t({
            id: 'socialExport.youtube.idealSize',
            defaultMessage: 'Tamaño ideal: 1280 x 720 px',
          }),
        }}
      />
    </Box>
  );
}
